//
//
//
//
//
//
//
//
//
//
import TermList from '@/views/other/components/TermList.vue';
import WeekList from '@/views/other/components/WeekList.vue';
export default {
  name: 'term-info',
  components: {
    TermList: TermList,
    WeekList: WeekList
  },
  data: function data() {
    return {
      activeTab: 'term',
      termMenus: [{
        key: 'term',
        title: '学期列表'
      }, {
        key: 'week',
        title: '教学周期表'
      }]
    };
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};